import { render, staticRenderFns } from "./CompanyProfileSettings.vue?vue&type=template&id=266ccba5&scoped=true"
import script from "./CompanyProfileSettings.vue?vue&type=script&lang=js"
export * from "./CompanyProfileSettings.vue?vue&type=script&lang=js"
import style0 from "./CompanyProfileSettings.vue?vue&type=style&index=0&id=266ccba5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266ccba5",
  null
  
)

export default component.exports